import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	errorMessage: {
		'id': 'typeAge.errorMessage',
		'defaultMessage': 'Age must be 14 or not older than 100',
	},
});


// WEBPACK FOOTER //
// ./src/components/AnswerTypeAge/messages.js